import { render, staticRenderFns } from "./OpenCloseIssues.vue?vue&type=template&id=1f0dde5c&scoped=true&"
import script from "./OpenCloseIssues.vue?vue&type=script&lang=js&"
export * from "./OpenCloseIssues.vue?vue&type=script&lang=js&"
import style0 from "./OpenCloseIssues.vue?vue&type=style&index=0&id=1f0dde5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@2.1.1_webpack@4.47.0__ejs@3.1.10_lodash@4.17.21_vue-templ_3032bbf5bf429ce3df9c2338882a5f47/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0dde5c",
  null
  
)

export default component.exports